import {
  KeyOutlined,
  SafetyCertificateOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import type { RolePermissionRequest } from '@zhiyue/core';
import { RolePermissionManager } from '@zhiyue/core';
import { Menu, Modal } from 'antd';
import { BizAppConfig } from 'config/application.manifest';
import React, { useState } from 'react';
import { createTenantManagementRequest } from '@/services/request';
import DataScopeManagement from './DataScopeManagement';

const request = createTenantManagementRequest();

const rolePermissionRequest: RolePermissionRequest = (url, options) =>
  request(url, {
    method: options?.method,
    params: options?.params as Record<string, unknown> | undefined,
    data: options?.data,
    headers: options?.headers,
  });

type SettingsMenuKey = 'permissions' | 'data-scopes';

const SETTINGS_MENU_ITEMS = [
  {
    key: 'permissions' as SettingsMenuKey,
    icon: <KeyOutlined />,
    label: '功能权限',
  },
  {
    key: 'data-scopes' as SettingsMenuKey,
    icon: <SafetyCertificateOutlined />,
    label: '数据范围',
  },
];

const TRIGGER_MENU_ITEM = [
  {
    key: 'settings-trigger',
    icon: <SettingOutlined />,
    label: '设置',
  },
];

interface SettingsModalProps {
  collapsed?: boolean;
  /** 外部控制弹窗显示状态，不传时组件自管理 */
  open?: boolean;
  /** 外部控制关闭回调 */
  onClose?: () => void;
}

const SettingsModal: React.FC<SettingsModalProps> = ({
  collapsed,
  open: openProp,
  onClose,
}) => {
  const [innerOpen, setInnerOpen] = useState(false);
  const open = openProp !== undefined ? openProp : innerOpen;
  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      setInnerOpen(false);
    }
  };
  const [activeKey, setActiveKey] = useState<SettingsMenuKey>('permissions');

  return (
    <>
      <Menu
        mode="inline"
        inlineCollapsed={collapsed}
        selectable={false}
        items={TRIGGER_MENU_ITEM}
        onClick={() => setInnerOpen(true)}
        style={{ borderInlineEnd: 'none' }}
      />
      <Modal
        title="系统设置"
        open={open}
        onCancel={handleClose}
        footer={null}
        width="90vw"
        styles={{
          body: {
            height: 'calc(90vh - 110px)',
            padding: 0,
            overflow: 'hidden',
          },
        }}
        style={{ top: 20 }}
        destroyOnHidden
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            height: '100%',
            width: '100%',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              width: 180,
              flexShrink: 0,
              borderRight: '1px solid #f0f0f0',
              height: '100%',
              overflowY: 'auto',
              background: '#fff',
            }}
          >
            <Menu
              mode="inline"
              selectedKeys={[activeKey]}
              items={SETTINGS_MENU_ITEMS}
              onClick={({ key }) => setActiveKey(key as SettingsMenuKey)}
              style={{ height: '100%', borderRight: 'none' }}
            />
          </div>
          <div
            style={{ flex: 1, overflow: 'auto', minWidth: 0, height: '100%' }}
          >
            {activeKey === 'permissions' && (
              <RolePermissionManager
                request={rolePermissionRequest}
                namespace={BizAppConfig.appPermissionAppId}
              />
            )}
            {activeKey === 'data-scopes' && <DataScopeManagement />}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SettingsModal;
